import { UserAdmin } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/** Доступы команды dodoc (БО-80): роли DODOC_*, обязательная MFA, журнал действий. Только DODOC_ADMIN. */
export const section = defineSection({
  id: 'backoffice.team',
  area: 'backoffice',
  path: 'team',
  roles: ['DODOC_ADMIN'],
  icon: UserAdmin,
  titleKey: 'boTeam:title',
  namespaces: ['portal', 'backoffice'],
  navGroup: 'system',
  order: 20,
  load: () => import('./TeamPage'),
});
